// use client: react-bootstrap's <Accordion> owns its open/closed state
// internally via context, so it cannot render as a Server Component.
'use client'

import type { CmsContactFaq } from '@/types/contact-us'

import { Accordion } from 'react-bootstrap'
import parse from 'html-react-parser'

interface ContactUsAccordionProps {
  faqs: CmsContactFaq[]
}

function ContactUsAccordion({ faqs }: ContactUsAccordionProps) {
  return (
    <Accordion defaultActiveKey="0" flush>
      {faqs.map((item, index) => (
        <Accordion.Item key={item.id ?? index} eventKey={index.toString()}>
          <div className="contact-us-accordion">
            <Accordion.Header>{parse(item.title ?? '')}</Accordion.Header>
            <Accordion.Body>{parse(item.content ?? '')}</Accordion.Body>
          </div>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}

export default ContactUsAccordion
